module.exports = __webpack_public_path__ + "static/media/kids-star.8ffd1814.png";